import { InteracEditEmailRequest } from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

const hook = vopayApi.withApiHook(({ api }) => {
  return function usePostEditInterac(bearer: string) {
    const source = axios.CancelToken.source();
    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const editInterac = async (requestParams: InteracEditEmailRequest) => {
      try {
        setDataFetchingInfo(true, '', 'fullScreen');
        const response = await api.postEditInteracEmail(requestParams, source, bearer);
        return response;
      } finally {
        setDataFetchingInfo(false);
      }
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      editInterac,
    };
  };
});

export default hook({});
